<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/cartloader";
import { ModelListSelect } from "vue-search-select";
import { mapActions, mapGetters, mapState } from "vuex";
import Swal from "sweetalert2";
import moment from "moment";
/**
 * Form Layouts component
 */
export default {
  page: {
    title: "New Production Batch",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, ModelListSelect, Loader },
  data() {
    return {
      title: "Record Production",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "New Production Batch",
          active: true,
        },
      ],
      selected: null,
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "item.name",
          sortable: true,
          label: "ITEM",
        },
        {
          key: "quantity",
          sortable: true,
          label: "QUANTITY",
        },
        {
          key: "unit_price",
          sortable: true,
          label: "UNIT PRICE",
        },
        {
          key: "selling_price",
          sortable: true,
          label: "SELLING PRICE",
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      existingItem: [],
      unitsArr: [],

      itemError: "",
      quantityError: "",
      priceError: "",
      modeError: "",
      unitError: "",
      nameError: "",
      contactError: "",
      customerError: "",
      productError: "",
      totals: {
        date: moment(new Date()).format("YYYY-MM-DD"),
        total: 0,
        total_brand: 0,
        cost_price: 0,
        product: '',
        factory: '',
        customer: '',
        charge_milling_on: 0
      },
      // edit item
      editdata: {
        id: "",
        name: "",
        product: "",
        quantity: "",
        unit_price: "",
        selling_price: 0,
        is_brand: 0,
      },
      // delete item
      deletedata: {
        name: "",
        id: "",
      },
      item_rate: 0,

      factorydata: {
        name: "",
        contact: "",
        location: ""
      },

      customerdata: {
        category_id: 1,
        contact: "",
        name: "",
        email: "",
      },
    };
  },

  computed: {
    // MAP STATE
    ...mapState("notification", ["type", "message", "show"]),
    ...mapGetters("production", ["ProductionCart", "SaveStatus", "OutputProducts"]),
    ...mapGetters("setting", ["GeneralSettings"]),
    ...mapGetters("auth", ["MyUserPerm"]),
    ...mapGetters("customers", ["Customers"]),
    ...mapGetters("factorystock", ["ProductionFactories"]),

    formattedFactories() {
      const factories = Array.isArray(this.ProductionFactories)
        ? this.ProductionFactories
        : Array.isArray(this.ProductionFactories?.data)
          ? this.ProductionFactories.data
          : []

      return [
        { id: '', name: 'Select Factory', location: '' },
        ...factories
      ].map(factory => ({
        ...factory,
        display_name: factory.location
          ? `${factory.name} - ${factory.location}`
          : factory.name
      }))
    },

    formattedCustomers() {
      const customers = Array.isArray(this.Customers)
        ? this.Customers
        : Array.isArray(this.Customers?.data)
          ? this.Customers.data
          : []

      return [
        { id: '', name: 'No Customer', contact: '' },
        ...customers
      ].map(factory => ({
        ...factory,
        display_name: factory.contact
          ? `${factory.name} - ${factory.contact}`
          : factory.name
      }))
    },

    /**
     * Total no. of records
     */

    rows() {
      return this.ProductionCart ? this.ProductionCart.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.ProductionCart ? this.ProductionCart.length : 1;
  },
  methods: {
    ...mapActions({
      FetchProductionCart: "production/fetchProductionCart",
      AddCart: "production/addToProductionCart",
      DeleteCartItem: "production/deleteProductionCart",
      EditCartItems: "production/editProductionCart",
      SaveBatch: "production/saveProduction",
      FetchGeneralSettings: "setting/fetchGeneralSettings",
      FetchOutputProducts: "production/fetchOutputProducts",
      AddProductionFactory: "production/addProductionFactory",
      FetchProductionFactories: "factorystock/fetchProductionFactories",
      FetchCustomers: "customers/fetchCustomers",
      AddCustomer: "customers/addCustomer",
    }),

    // COMMA SEPERATORS
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    editPriceCommas() {
      this.editdata.unit_price = this.editdata.unit_price ? this.thousandSeprator(this.editdata.unit_price) : '';
      this.editdata.selling_price = this.editdata.selling_price ? this.thousandSeprator(this.editdata.selling_price) : '';
    },
    resetCustomer() {
      this.customerdata.contact = "";
      this.customerdata.name = "";
      this.customerdata.email = "";
    },
    resetDeleteItem(modalId) {
      this.closeModal(modalId);
      this.deletedata.name = "";
      this.deletedata.id = "";
      this.modal_id = "";
    },
    resetEdit(modalId) {
      this.closeModal(modalId);
      this.editdata.product = "";
      this.editdata.id = "";
      this.editdata.quantity = "";
      this.editdata.unit_price = "";
      this.editdata.selling_price = "";
      this.editdata.is_brand = "";
      this.modal_id = "";
    },

    resetErrors() {
      this.itemError = "";
      this.quantityError = "";
      this.priceError = "";
      this.unitError = "";
      this.nameError = "";
      this.contactError = "";
      this.customerError = "";
      this.productError = "";
    },

    showEditModal(data) {
      this.editdata.product = data.item.id;
      this.editdata.name = data.item.name;
      this.editdata.id = data.id;
      this.editdata.quantity = data.quantity;
      this.editdata.expiry = data.expiry;
      this.editdata.batch = data.batch;
      this.editdata.is_brand = data.item.is_brand;
      this.editdata.unit_price = this.thousandSeprator(data.unit_price);
      this.editdata.selling_price = this.thousandSeprator(data.selling_price);
    },

    showDeleteModal(data) {
      this.deletedata.name = data.item.name;
      this.deletedata.id = data.id;
    },
    editItem(modalId) {
      this.modal_id = modalId;
      this.EditCartItems(this.editdata);
    },

    deleteItem(modalId) {
      this.modal_id = modalId;
      this.DeleteCartItem(this.deletedata);
    },
    saveBatch() {
      if(this.totals.product == "" && this.GeneralSettings.produce_multiple_products == 1){
        this.productError = "Output Product is required";
        return;
      }
      this.SaveBatch(this.totals);
    },
    addToCart() {
      if(this.totals.product == "" && this.GeneralSettings.produce_multiple_products == 1){
        this.productError = "Output Product is required";
        return;
      }
      this.AddCart(this.totals);
    },
    paidCommas() {
      this.totals.paid = this.thousandSeprator(this.totals.paid);
    },
    discountCommas() {
      this.totals.discount = this.thousandSeprator(this.totals.discount);
    },
    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
        this.resetErrors();
        this.resetFactory();
      });
    },

    resetPaidError() {
      this.PaidError = "";
    },

    resetTotals() {
      this.totals.total = 0;
      this.total_brand = 0,
      this.cost_price = 0,
      this.totals.factory = "";
      this.totals.customer = "";
      this.totals.date = moment(new Date()).format("YYYY-MM-DD");
    },

    // Validate Factory Data
    validateFactory() {
      if (this.factorydata.name != "" && this.factorydata.contact != '') {
        let faactoryData = this.ProductionFactories.filter((item) => {
          return item.contact == parseInt(this.factorydata.contact);
        })
        let factoryCount = faactoryData.length;
        if (factoryCount > 0) {
          this.contactError = "Factory with contact " + this.factorydata.contact + "  already Exists";
        }
      } else if (this.factorydata.name != "" && this.factorydata.contact == '') {
        let faactoryData = this.ProductionFactories.filter((item) => {
          return (item.name).toLowerCase() == (this.factorydata.name).toLowerCase();
        })
        let factoryCount = faactoryData.length;
        if (factoryCount > 0) {
          this.contactError = "Factory with these details already Exists";
        }
      }
    },

    addFactory(modalId) {
      this.modal_id = modalId;
      if (this.factorydata.name === "") {
        this.nameError = "Name field is required";
        return;
      } else {
        this.nameError = "";
      }
      this.validateFactory()
      if (this.contactError != "") {
        return
      }
      this.AddProductionFactory(this.factorydata);
    },

    resetFactory() {
      this.factorydata.contact = "";
      this.factorydata.name = "";
      this.factorydata.location = "";
    },

    // Validate Customer records
    validateCustomer() {
      if (this.customerdata.name != "" && this.customerdata.contact != '') {
        let selCust = this.Customers.filter((item) => {
          return item.phone == parseInt(this.customerdata.contact);
        })
        let custCount = selCust.length;
        if (custCount > 0) {
          this.contactError = "Customer with contact " + this.customerdata.contact + "  already Exists";
        }
      } else if (this.customerdata.name != "" && this.customerdata.contact == '') {
        let selCust = this.Customers.filter((item) => {
          return (item.name).toLowerCase() == (this.customerdata.name).toLowerCase();
        })
        let custCount = selCust.length;
        if (custCount > 0) {
          this.contactError = "Customer with these details already Exists";
        }
      }
    },

    // Add Customer
    addCustomer(modalId) {
      this.modal_id = modalId;
      if (this.customerdata.name === "") {
        this.nameError = "Name field is required";
        return;
      } else {
        this.nameError = "";
      }

      this.validateCustomer()
      if (this.contactError != "") {
        return
      }

      this.AddCustomer(this.customerdata);
      this.totals.customer = this.Customers[0].name - this.Customers[0].contact;
      this.closeModal(modalId);
    },

    calculateTotals() {
      let totalAmount = 0;
      let totalBrand = 0;
      let totalQuantity = 0;

      this.ProductionCart.forEach((item) => {
        const d = item.item;

        const isProduct = d.is_product == 1;
        const isFinal = d.is_final_product == 1;
        const isBrand = d.is_brand == 1;
        const isBaseZero = d.is_base == 0;

        let includeInAmount = false;

        // =========================
        // OUTPUT MODE (0)
        // =========================
        if (this.totals.charge_milling_on == 0) {

          includeInAmount = (isProduct || isFinal || isBrand || isBaseZero);

        }
        // =========================
        // INPUT MODE (1)
        // =========================
        else {

          includeInAmount = (
            isProduct ||
            d.is_final_product == 0 ||
            isBrand ||
            d.is_base == 1
          );
        }

        // =========================
        // SAFE FALLBACK (ONLY ONCE)
        // =========================
        const isZeroItem =
          d.is_product == 0 &&
          d.is_final_product == 0 &&
          d.is_brand == 0 &&
          d.is_base == 0;

        if (isZeroItem) {
          includeInAmount = true; // but only once
        }

        // =========================
        // APPLY ONCE ONLY
        // =========================
        if (includeInAmount) {
          if (d.is_product == 1 || d.is_base == 1 || d.is_final_product == 1) {
            totalAmount += item.unit_price * item.quantity;
          }
          totalBrand += item.selling_price * item.quantity;
        }

        // =========================
        // Quantity logic (unchanged)
        // =========================
        if (d.is_final_product == 1 && d.is_product == 0) {
          totalQuantity += item.quantity;
        }
      });

      this.totals.total = totalAmount;
      this.totals.total_brand = totalBrand;

      this.totals.cost_price =
        totalQuantity > 0
          ? Math.round((totalAmount - totalBrand) / totalQuantity)
          : 0;
    }

  },

  watch: {
    show(newValue) {
      // Do whatever makes sense now
      if (newValue) {
        if (this.type == "success") {
          this.closeModal(this.modal_id);
          this.resetTotals();
          Swal.fire("Success!", this.message.msg, "success");
          // this.$toast.success(this.message.msg);
        } else {
          // this.$toast.error(this.message.msg);
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
    Products(newValue) {
      if (newValue) {
        let pdts = this.Products.filter((item) => {
          return item.mainstock == 1;
        });
        this.totals.product = pdts[0].id;
      }
    },
    GeneralSettings(newValue) {
      if (newValue && newValue.attach_productionbatch_customer == 1) {
        this.FetchCustomers();
      }
      if (newValue && newValue.multiple_factories == 1) {
        this.FetchProductionFactories();
      }
      if (newValue && newValue.produce_multiple_products == 1) {
        this.FetchOutputProducts();
      }
    },
    ProductionCart: {
      handler: 'calculateTotals',
      deep: true
    },
    'totals.charge_milling_on': 'calculateTotals'
  },
  created() {
    this.FetchProductionCart();
    this.FetchGeneralSettings();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">

            <!-- Header -->
            <div class="row align-items-end g-2">

              <!-- Product Output -->
              <div class="col-12 col-md-4"
                v-if="GeneralSettings.use_ingredients == 1 && GeneralSettings.produce_multiple_products == 1">
                <label class="form-label mb-1">Select Output Product</label>

                <model-list-select :list="OutputProducts || []" v-model="totals.product" option-value="id" option-text="name"
                  placeholder="Select Product" @input="resetErrors()">
                </model-list-select>
                <div class="text-danger" v-if="productError">
                  <em>{{ productError }}</em>
                </div>
              </div>

              <!-- Add Button -->
              <div class="col-12 col-md-8 d-flex justify-content-md-end">
                <b-button @click="addToCart()" variant="primary" class="px-4 d-flex align-items-center"
                  :disabled="SaveStatus">
                  <i class="fa fa-plus me-2"></i>

                  <span>Add Items</span>

                  <b-spinner v-if="SaveStatus" small variant="light" class="ms-2"></b-spinner>
                </b-button>
              </div>

            </div>

            <!-- Search + Entries -->
            <div class="row mt-3 g-2">

              <div class="col-12 col-md-6">
                <label class="d-flex align-items-center">
                  Show&nbsp;
                  <b-form-select class="form-select form-select-sm w-auto" v-model="perPage" size="sm"
                    :options="pageOptions"></b-form-select>
                  &nbsp;entries
                </label>
              </div>

              <div class="col-12 col-md-6 text-md-end">
                <label class="d-flex align-items-center justify-content-md-end">
                  Search:
                  <b-form-input v-model="filter" type="search" placeholder="Search..."
                    class="form-control form-control-sm ms-2"></b-form-input>
                </label>
              </div>

            </div>

            <!-- Table -->
            <div class="table-responsive mt-3">
              <b-table class="datatables" :items="ProductionCart ? ProductionCart : []" :fields="fields" responsive="sm"
                :per-page="perPage" :current-page="currentPage" :sort-desc.sync="sortDesc" :filter="filter"
                :filter-included-fields="filterOn" @filtered="onFiltered">

                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>

                <template #cell(total_price)="data">
                  {{
                    data.item.unit_price
                      ? thousandSeprator(data.item.quantity * data.item.unit_price)
                      : 0
                  }}
                </template>

                <template #cell(unit_price)="data">
                  {{
                    data.item.unit_price
                      ? thousandSeprator(data.item.unit_price)
                      : 0
                  }}
                </template>

                <template #cell(quantity)="data">
                  {{ data.item ? data.item.quantity : 0 }}
                  {{ data.item.unit.unitsym }}
                </template>

                <template #cell(actions)="data">

                  <div class="d-flex flex-wrap gap-1">

                    <b-button v-if="MyUserPerm.edit_consumables == 1" size="sm" variant="primary"
                      v-b-modal.edit-item-modal @click="showEditModal(data.item)">
                      <i class="fa fa-edit"></i> Update
                    </b-button>

                    <b-button v-if="MyUserPerm.delete_consumables == 1" v-b-modal.delete-item-modal variant="danger"
                      size="sm" @click="showDeleteModal(data.item)">
                      <i class="fa fa-trash"></i> Delete
                    </b-button>

                  </div>

                </template>

              </b-table>

              <!-- Pagination -->
              <div class="row mt-2">
                <div class="col-12 d-flex justify-content-end">
                  <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" size="sm"
                    class="mb-4"></b-pagination>
                </div>
              </div>

            </div>

            <Loader v-if="!ProductionCart" />

            <!-- Totals -->
            <div class="row" v-if="totals.total > 0">
              <div class="col-12 text-center mt-4">

                <h5>
                  <strong>TOTAL: {{ thousandSeprator(totals.total) }}/=</strong>
                </h5>

                <h5>
                  <strong>
                    TOTAL BRAND: {{ thousandSeprator(totals.total_brand) }}/=
                  </strong>
                </h5>

                <h5>
                  <strong>
                    AVERAGE COST: {{ thousandSeprator(totals.cost_price) }}/=
                  </strong>
                </h5>

              </div>
            </div>

            <!-- FORM -->
            <b-form v-if="totals.total > 0">

              <div class="row g-2">
                <div class="col-12 col-md-4">
                  <label>
                    Select Factory
                    <b-button size="sm" variant="link" v-b-modal.add-factory-modal>
                      New Factory
                    </b-button>
                  </label>
                  <model-list-select :list="formattedFactories" v-model="totals.factory" option-value="id"
                    option-text="display_name" placeholder="Select Factory">
                  </model-list-select>
                </div>

                <div class="col-12 col-md-4" v-if="GeneralSettings.attach_productionbatch_customer == 1">
                  <label>
                    Select Customer
                    <b-button size="sm" variant="link" v-b-modal.add-customer-modal>
                      New Customer
                    </b-button>
                  </label>
                  <model-list-select :list="formattedCustomers" v-model="totals.customer" option-value="id"
                    option-text="display_name" placeholder="Select Customer">
                  </model-list-select>
                </div>

                <div class="col-12 col-md-3">
                  <label>
                    Production Date <span class="text-danger">*</span>
                  </label>
                  <input type="date" class="form-control" v-model="totals.date" v-limit-future-date />
                </div>

                <div class="col-12 col-md-3" v-if="GeneralSettings.use_multiple_millingcharge_calculations == 1">
                  <label>
                    Charge Milling On <span class="text-danger">*</span>
                  </label>
                  <select class="form-control" v-model.number="totals.charge_milling_on">
                    <option :value="0">Output</option>
                    <option :value="1">Input</option>
                  </select>
                </div>


                <div v-if="MyUserPerm.stocking_consumables == 1" class="col-12 col-md-2 d-grid mt-2">

                  <b-button v-if="SaveStatus" variant="primary" disabled>
                    <i class="fa fa-check"></i> Saving Batch
                    <b-spinner variant="light" small></b-spinner>
                  </b-button>

                  <b-button v-else variant="primary" @click="saveBatch()">
                    <i class="fa fa-check"></i> Save Batch
                  </b-button>

                </div>

              </div>

            </b-form>

          </div>
        </div>
      </div>
    </div>

    <!-- Factory modal starts -->
    <b-modal id="add-factory-modal" hide-footer @hidden="resetFactory">
      <template #modal-title> Add Factory </template>

      <div class="form-group mb-3">
        <label>Factory Name <span class="text-danger">*</span></label>
        <div class="input-group">
          <input type="text" placeholder="Enter Name " class="form-control" @input="resetErrors()"
            v-model="factorydata.name" />
        </div>
        <div class="text-danger" v-if="nameError">
          <em>{{ nameError }}</em>
        </div>
      </div>

      <div class="form-group mb-3">
        <label>Factory Contact</label>
        <div class="input-group">
          <input type="number" placeholder="Enter Factory Contact" class="form-control" v-model="factorydata.contact"
            @input="resetErrors()" />
        </div>
        <div class="text-danger" v-if="contactError">
          <em>{{ contactError }}</em>
        </div>
      </div>

      <div class="form-group mb-3">
        <label>Factory Location</label>
        <div class="input-group">
          <input type="text" placeholder="Enter Factory Location" class="form-control" v-model="factorydata.location" />
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-danger" data-dismiss="modal" @click="closeModal('add-factory-modal')">
          <i class="fa fa-times"></i> Close
        </button>
        <button v-if="SaveStatus" type="button" class="btn btn-primary"> <i class="fa fa-check"></i>
          Submit
          <b-spinner disabled variant="light" small label="Spinning"></b-spinner>
        </button>
        <button v-else type="button" class="btn btn-primary" @click="addFactory('add-factory-modal')"> <i
            class="fa fa-check"></i>
          Submit
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->

    <!-- Customer modal starts -->
    <b-modal id="add-customer-modal" hide-footer @hidden="resetCustomer">
      <template #modal-title> Add Customer </template>

      <div class="form-group mb-3">
        <label>Customer Name <span class="text-danger">*</span></label>
        <div class="input-group">
          <input type="text" placeholder="Enter Name " class="form-control" @input="resetErrors()"
            v-model="customerdata.name" />
        </div>
        <div class="text-danger" v-if="nameError">
          <em>{{ nameError }}</em>
        </div>
      </div>

      <div class="form-group mb-3">
        <label>Customer Contact</label>
        <div class="input-group">
          <input type="number" placeholder="Enter Phone Number" class="form-control" v-model="customerdata.contact"
            @input="resetErrors()" />
        </div>
        <div class="text-danger" v-if="contactError">
          <em>{{ contactError }}</em>
        </div>
      </div>

      <div class="form-group mb-3">
        <label>Customer Email</label>
        <div class="input-group">
          <input type="text" placeholder="Enter Email" class="form-control" v-model="customerdata.email" />
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-danger" data-dismiss="modal" @click="closeModal('add-customer-modal')">
          <i class="fa fa-times"></i> Close
        </button>
        <button v-if="SaveStatus" type="button" class="btn btn-primary"> <i class="fa fa-check"></i>
          Submit
          <b-spinner disabled variant="light" small label="Spinning"></b-spinner>
        </button>
        <button v-else type="button" class="btn btn-primary" @click="addCustomer('add-customer-modal')"> <i
            class="fa fa-check"></i>
          Submit
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->

    <!-- modal edit item starts -->
    <b-modal id="edit-item-modal" class="text-primary" hide-footer @hidden="resetEdit()">
      <template #modal-title> Edit Item {{ editdata.name }}</template>
      <div class="form-group mb-3">
        <label>Quantity</label>
        <input type="number" class="form-control" step="any" v-model="editdata.quantity" />
      </div>
      <div class="form-group mb-3">
        <label>Unit Price</label>
        <input type="text" class="form-control" step="any" v-model="editdata.unit_price" @input="editPriceCommas()" />
      </div>
      <div class="form-group mb-3" v-if="editdata.is_brand == 1">
        <label>Selling Price</label>
        <input type="text" class="form-control" step="any" v-model="editdata.selling_price"
          @input="editPriceCommas()" />
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-danger" data-dismiss="modal" @click="closeModal('edit-item-modal')">
          <i class="fa fa-times"></i> Close
        </button>
        <button type="button" class="btn btn-primary" @click="editItem('edit-item-modal')">
          <i class="fa fa-check"></i> Save Changes
          <b-spinner v-if="SaveStatus" variant="light" small label="Deleting"></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->

    <!-- modal delete expense starts -->
    <b-modal id="delete-item-modal" class="text-danger" hide-footer @hidden="resetDeleteItem">
      <template #modal-title> Delete {{ deletedata.name }}</template>
      <div class="form-group mb-3">
        <div class="input-group">
          <h5>Do you want to remove this item? Click Proceed to continue.</h5>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="closeModal('delete-item-modal')">
          <i class="fa fa-times"></i> Close
        </button>
        <button type="button" class="btn btn-danger" @click="deleteItem('delete-item-modal')">
          <i class="fa fa-trash"></i> Proceed
          <b-spinner v-if="SaveStatus" variant="light" small label="Deleting"></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->

    <!--  end row -->
  </Layout>
</template>
<style>
.btn-primary,
.page-link {
  background-color: #fab031 !important;
  border-color: #fab031 !important;
}
</style>